export default __webpack_public_path__ + "static/women-bodymap-face-cd788f354927882474f4fbf310c3a10a.webp";